//
// Background component
//

// Imports
import React from "react";
import "./background.scss";

// Background versions
export default function Background() {
  return <div className="background"></div>;
}

export function BackgroundDark() {
  return <div className="background background--dark"></div>;
}
